import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AdminAuthProvider, useAdminAuth } from '../contexts/AdminAuthContext';
import AdminLayout from './admin/AdminLayout';
import AdminDashboard from './admin/AdminDashboard';
import AdminLogin from './admin/AdminLogin';
import AdminProtectedRoute from './admin/AdminProtectedRoute';
import AdminServices from './admin/pages/AdminServices';
import AdminQuoteRequests from './admin/pages/AdminQuoteRequests';
import AdminOfferRequests from './admin/pages/AdminOfferRequests';
import AdminMeetingRequests from './admin/pages/AdminMeetingRequests';
import AdminConsultationRequests from './admin/pages/AdminConsultationRequests';
import AdminVpsPackages from './admin/pages/AdminVpsPackages';
import AdminVdsPackages from './admin/pages/AdminVdsPackages';
import AdminCorporateServerPackages from './admin/pages/AdminCorporateServerPackages';
// removed dedicated pages
import AdminHostingPackages from './admin/pages/AdminHostingPackages';
import AdminWordPressHostingPackages from './admin/pages/AdminWordPressHostingPackages';
import AdminEcommercePackages from './admin/pages/AdminEcommercePackages';
import AdminProEcommercePackages from './admin/pages/AdminProEcommercePackages';
import AdminB2BPackages from './admin/pages/AdminB2BPackages';
import AdminSeoPackages from './admin/pages/AdminSeoPackages';
import AdminAdvertisingPackages from './admin/pages/AdminAdvertisingPackages';
import AdminEcommerceFeatures from './admin/pages/AdminEcommerceFeatures';
import AdminEcommerceDesignCategories from './admin/pages/AdminEcommerceDesignCategories';
import AdminEcommerceDesigns from './admin/pages/AdminEcommerceDesigns';
import AdminProjectCategories from './admin/pages/AdminProjectCategories';
import AdminProjects from './admin/pages/AdminProjects';
import AdminSubcategories from './admin/pages/AdminSubcategories';
import AdminBlogs from './admin/pages/AdminBlogs';
import AdminBlogCategories from './admin/pages/AdminBlogCategories';
import AdminMedia from './admin/pages/AdminMedia';
import AdminReferences from './admin/pages/AdminReferences';
import AdminReferenceCategories from './admin/pages/AdminReferenceCategories';
import AdminCorporatePackages from './admin/pages/AdminCorporatePackages';
import AdminCorporateDesigns from './admin/pages/AdminCorporateDesigns';
import AdminCorporateDesignCategories from './admin/pages/AdminCorporateDesignCategories';
import AdminNewsletter from './admin/pages/AdminNewsletter';
import AdminEmailTemplates from './admin/pages/AdminEmailTemplates';
import AdminSettings from './admin/pages/AdminSettings';
import AdminFAQ from './admin/pages/AdminFAQ';
import AdminPopup from './admin/pages/AdminPopup';
import AdminSitemap from './admin/pages/AdminSitemap';
import AdminUsers from './admin/pages/AdminUsers';
import AdminWebsiteTemplates from './admin/pages/AdminWebsiteTemplates';
import AdminWebsiteTemplateCategories from './admin/pages/AdminWebsiteTemplateCategories';
import AdminKolaySitePackages from './admin/pages/AdminKolaySitePackages';
import AdminDomainPrices from './admin/pages/AdminDomainPrices';
import AdminEcommerceHostingPackages from './admin/pages/AdminEcommerceHostingPackages';
// removed mail hosting admin pages
import AdminResellerHostingPackages from './admin/pages/AdminResellerHostingPackages';
import AdminSSL from './admin/pages/AdminSSL';
import AdminMarkaTescilClasses from './admin/pages/AdminMarkaTescilClasses';
import AdminMarkaTescilApplications from './admin/pages/AdminMarkaTescilApplications';
import AdminMarkaTescilAdditionalServices from './admin/pages/AdminMarkaTescilAdditionalServices';
import AdminEducations from './admin/pages/AdminEducations';
import AdminEducationCategories from './admin/pages/AdminEducationCategories';
import AdminPageSeo from './admin/pages/AdminPageSeo';
import AdminPageContents from './admin/pages/AdminPageContents';
import AdminCookies from './admin/pages/AdminCookies';
import AdminKvkk from './admin/pages/AdminKvkk';
import AdminGogiAI from './admin/pages/AdminGogiAI';
import AdminGogiConversations from './admin/pages/AdminGogiConversations';
import AdminGogiCustomers from './admin/pages/AdminGogiCustomers';
import AdminGogiQuickReplies from './admin/pages/AdminGogiQuickReplies';
import AdminMenus from './admin/pages/AdminMenus';
import AdminCoupons from './admin/pages/AdminCoupons';
import AdminBusinesses from './admin/pages/AdminBusinesses';
import AdminProfile from './admin/pages/AdminProfile';

// Rol bazlı route koruması bileşeni
const RoleProtectedRoute = ({ children, allowedRoles }) => {
  const { adminUser } = useAdminAuth();
  const userRole = adminUser?.role || 'content_writer';
  
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/admin" replace />;
  }
  
  return children;
};

const AdminPanelContent = () => {
  return (
    <Routes>
      <Route path="/login" element={<AdminLogin />} />
      <Route path="/*" element={
        <AdminProtectedRoute>
          <AdminLayout>
            <Routes>
              {/* Dashboard - Sadece admin */}
              <Route path="/" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </RoleProtectedRoute>
              } />
              <Route path="/dashboard" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminDashboard />
                </RoleProtectedRoute>
              } />
              
              {/* Hizmetler - Editör ve Admin */}
              <Route path="/services" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminServices />
                </RoleProtectedRoute>
              } />
              
              {/* Talepler - Editör ve Admin */}
              <Route path="/quote-requests" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminQuoteRequests />
                </RoleProtectedRoute>
              } />
              <Route path="/meeting-requests" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminMeetingRequests />
                </RoleProtectedRoute>
              } />
              <Route path="/offer-requests" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminOfferRequests />
                </RoleProtectedRoute>
              } />
              <Route path="/consultation-requests" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminConsultationRequests />
                </RoleProtectedRoute>
              } />
              <Route path="/businesses" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminBusinesses />
                </RoleProtectedRoute>
              } />
              <Route path="/newsletter" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminNewsletter />
                </RoleProtectedRoute>
              } />
              <Route path="/email-templates" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEmailTemplates />
                </RoleProtectedRoute>
              } />
              
              {/* VPS Paketleri - Editör ve Admin */}
              <Route path="/vps-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminVpsPackages />
                </RoleProtectedRoute>
              } />

              {/* VDS Paketleri - Editör ve Admin */}
              <Route path="/vds-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminVdsPackages />
                </RoleProtectedRoute>
              } />

              {/* Kurumsal Sunucu Paketleri - Editör ve Admin */}
              <Route path="/corporate-server-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminCorporateServerPackages />
                </RoleProtectedRoute>
              } />

              {/* Hosting Paketleri - Editör ve Admin */}
              <Route path="/hosting-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminHostingPackages />
                </RoleProtectedRoute>
              } />
              {/* WordPress Hosting Paketleri - Editör ve Admin */}
              <Route path="/wordpress-hosting-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminWordPressHostingPackages />
                </RoleProtectedRoute>
              } />
              
              {/* E-ticaret Paketleri - Editör ve Admin */}
              <Route path="/ecommerce-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEcommercePackages />
                </RoleProtectedRoute>
              } />
              <Route path="/pro-ecommerce-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminProEcommercePackages />
                </RoleProtectedRoute>
              } />
              <Route path="/b2b-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminB2BPackages />
                </RoleProtectedRoute>
              } />
              <Route path="/seo-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminSeoPackages />
                </RoleProtectedRoute>
              } />
              <Route path="/advertising-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminAdvertisingPackages />
                </RoleProtectedRoute>
              } />
              <Route path="/ecommerce-features" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEcommerceFeatures />
                </RoleProtectedRoute>
              } />
              
              {/* Website Templates - Editör ve Admin */}
              <Route path="/website-templates" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminWebsiteTemplates />
                </RoleProtectedRoute>
              } />
              <Route path="/website-template-categories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminWebsiteTemplateCategories />
                </RoleProtectedRoute>
              } />

              {/* Kolay Site Paketleri - Editör ve Admin */}
              <Route path="/kolay-site-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminKolaySitePackages />
                </RoleProtectedRoute>
              } />
              
              {/* Kurumsal Paketleri - Editör ve Admin */}
              <Route path="/corporate-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminCorporatePackages />
                </RoleProtectedRoute>
              } />
              <Route path="/corporate-designs" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminCorporateDesigns />
                </RoleProtectedRoute>
              } />
              <Route path="/corporate-design-categories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminCorporateDesignCategories />
                </RoleProtectedRoute>
              } />
              
              {/* Domain Fiyatları - Editör ve Admin */}
              <Route path="/domain-prices" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminDomainPrices />
                </RoleProtectedRoute>
              } />
              
              {/* E-Ticaret Hosting Paketleri - Editör ve Admin */}
              <Route path="/ecommerce-hosting-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEcommerceHostingPackages />
                </RoleProtectedRoute>
              } />
              
              {/* Bayi Hosting Paketleri - Editör ve Admin */}
              {/* SSL - Editör ve Admin */}
              <Route path="/ssl" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminSSL />
                </RoleProtectedRoute>
              } />
              {/* Marka Tescil - Editör ve Admin */}
              <Route path="/marka-tescil/classes" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminMarkaTescilClasses />
                </RoleProtectedRoute>
              } />
              <Route path="/marka-tescil/applications" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminMarkaTescilApplications />
                </RoleProtectedRoute>
              } />
              <Route path="/marka-tescil/additional-services" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminMarkaTescilAdditionalServices />
                </RoleProtectedRoute>
              } />
              {/* Education Management - Editör ve Admin */}
              <Route path="/educations" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEducations />
                </RoleProtectedRoute>
              } />
              <Route path="/education-categories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEducationCategories />
                </RoleProtectedRoute>
              } />
              {/* Sayfalar - Admin */}
              <Route path="/pages" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminPageSeo />
                </RoleProtectedRoute>
              } />
              <Route path="/page-contents" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminPageContents />
                </RoleProtectedRoute>
              } />
              <Route path="/menus" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminMenus />
                </RoleProtectedRoute>
              } />
              <Route path="/cookies" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminCookies />
                </RoleProtectedRoute>
              } />
              <Route path="/kvkk" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminKvkk />
                </RoleProtectedRoute>
              } />
              <Route path="/gogiai" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminGogiAI />
                </RoleProtectedRoute>
              } />
              <Route path="/gogiai-conversations" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminGogiConversations />
                </RoleProtectedRoute>
              } />
              <Route path="/gogiai-customers" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminGogiCustomers />
                </RoleProtectedRoute>
              } />
              <Route path="/gogiai-quick-replies" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminGogiQuickReplies />
                </RoleProtectedRoute>
              } />
              <Route path="/reseller-hosting-packages" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminResellerHostingPackages />
                </RoleProtectedRoute>
              } />
              
              {/* E-ticaret Tasarımları - Editör ve Admin */}
              <Route path="/ecommerce-design-categories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEcommerceDesignCategories />
                </RoleProtectedRoute>
              } />
              <Route path="/ecommerce-designs" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminEcommerceDesigns />
                </RoleProtectedRoute>
              } />
              
              {/* Projeler - Editör ve Admin */}
              <Route path="/project-categories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminProjectCategories />
                </RoleProtectedRoute>
              } />
              <Route path="/projects" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminProjects />
                </RoleProtectedRoute>
              } />
              <Route path="/subcategories" element={
                <RoleProtectedRoute allowedRoles={['admin', 'editor']}>
                  <AdminSubcategories />
                </RoleProtectedRoute>
              } />

              {/* Kolay Site sayfası kaldırıldı */}
              
                  {/* İçerik Yönetimi - Tüm roller */}
                  <Route path="/blogs" element={<AdminBlogs />} />
                  <Route path="/blog-categories" element={<AdminBlogCategories />} />
                  <Route path="/media" element={<AdminMedia />} />
              <Route path="/references" element={<AdminReferences />} />
              <Route path="/reference-categories" element={<AdminReferenceCategories />} />
              <Route path="/faq" element={<AdminFAQ />} />
              <Route path="/popup" element={<AdminPopup />} />
              <Route path="/sitemap" element={<AdminSitemap />} />
              <Route path="/coupons" element={<AdminCoupons />} />
              
              {/* Kullanıcı Yönetimi - Sadece Admin */}
              <Route path="/users" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminUsers />
                </RoleProtectedRoute>
              } />
              
              {/* Profil - Tüm roller */}
              <Route path="/profile" element={<AdminProfile />} />
              
              {/* Ayarlar - Sadece Admin */}
              <Route path="/settings" element={
                <RoleProtectedRoute allowedRoles={['admin']}>
                  <AdminSettings />
                </RoleProtectedRoute>
              } />
              
              {/* Catch all - Rol bazlı yönlendirme */}
              <Route path="*" element={<Navigate to="/admin" replace />} />
            </Routes>
          </AdminLayout>
        </AdminProtectedRoute>
      } />
    </Routes>
  );
};

const AdminPanel = () => {
  return (
    <AdminAuthProvider>
      <AdminPanelContent />
    </AdminAuthProvider>
  );
};

export default AdminPanel; 